/* Luvlyn · de productpagina. Port van js/product.js van de
   ontwerpsite (fase 3, 04-10-2026). Alleen de gekozen varianten.
   1. (Het geluid en de chat zitten sinds 04-10 in assets/site.js: één speler voor de hele site.)
   2. De kleur: één keuze voor de hele pagina. Een kleur is een variant: de mandjesknoppen krijgen
      het variant-id (assets/site.js legt hem in de winkelwagen), de link krijgt ?variant=, en een
      uitverkochte kleur zet de knoppen uit.
   3. Het aantal (staffeltegels), de galerij (onder elkaar, op mobiel vegen) en de lightbox, ook met het
      toetsenbord (audit 05-10).
   3b. Het koopblok loopt mee: eerst scrollen tot de onderkant in beeld is, dan pas vastzetten.
   4. (De plakbalk staat sinds 05-10 in assets/plakbalk.js: hij werkt op elk sjabloon.)
   5. Per sectie: wat hij kan (het dak, de beelden pas vlak voor hun beurt), de golven en de reviews.
   De gegevens staan in [data-product-data] (sections/luvlyn-product.liquid). */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const bron = $('[data-product-data]');
  if (!bron) return;
  const D = JSON.parse(bron.textContent);
  const L = window.Luvlyn = window.Luvlyn || {};
  const stil = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const gedrag = () => (stil ? 'auto' : 'smooth');
  const vul = (s, w) => String(s || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => w[k] ?? '').replace(/\[(\w+)\]/g, (_, k) => w[k] ?? '');
  // de geluiden en de speler zitten in assets/site.js (Luvlyn.geluiden, één speler voor de hele site)
  const GELUID = L.geluiden || {};
  const GELUIDEN = Object.keys(GELUID);
  let kleur = D.begin;

  const toast = $('#toast'); let tt;
  const meld = tekst => { if (!toast) return; toast.textContent = tekst; toast.classList.add('aan'); clearTimeout(tt); tt = setTimeout(() => toast.classList.remove('aan'), 3400); };

  const galB = $('[data-galerij="b"]');

  /* =================== 2. de kleur =================== */
  const breedUrl = (url, w) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=${w}` : '');
  // bericht als een kleur er weer is (snippets/terug-melding.liquid): alleen bij een uitverkochte kleur, met
  // die kleur als tag. Staat vóór zetKleur, want ?kleur= roept die al bij het laden aan.
  // Versturen doet de browser zelf, langs de hCaptcha van Shopify (die laadt bij de eerste focus in het veld
  // en voegt het token toe). Een fetch kan dat niet: die krijgt "Missing CAPTCHA token" (400) of de
  // botcontrole (403). Shopify stuurt terug naar deze url, met de kleur in ?variant=, en toont de bevestiging.
  // Shopify stuurt na het versturen terug zonder ?variant= (05-10: aanmelden op Wolk gaf de bevestiging op Berk).
  // Daarom onthoudt de form bij het versturen de kleur, en zet de pagina hem na de terugsprong terug (verderop).
  const TERUG = 'luvlyn-terug-kleur';
  const terugOpslag = v => { try { if (v === undefined) return sessionStorage.getItem(TERUG); if (v) sessionStorage.setItem(TERUG, v); else sessionStorage.removeItem(TERUG); } catch { return null; } };
  const gepost = !!$('[data-terug-klaar]')?.textContent.trim();
  const terugKleur = gepost ? terugOpslag() : null;
  terugOpslag(null);
  document.addEventListener('submit', e => { if (e.target.matches('[data-terug-form]')) terugOpslag(kleur); });
  const aangemeld = new Set();
  if (gepost) aangemeld.add(D.kleuren[terugKleur] ? terugKleur : kleur);
  function zetTerug(){
    const K = D.kleuren[kleur], klaar = aangemeld.has(kleur);
    $$('[data-terug]').forEach(el => {
      el.hidden = K.beschikbaar;
      $$('[data-terug-naam]', el).forEach(n => { n.textContent = K.naam; });
      $('[data-terug-tags]', el).value = `terug-op-voorraad, terug-${kleur}`;
      $('[data-terug-vraag]', el).hidden = klaar;
      $('[data-terug-klaar]', el).textContent = klaar ? vul(D.tekst.terugKlaar, { naam: K.naam }) : '';
      $('[data-terug-fout]', el).textContent = '';
    });
  }
  function zetKleur(k, { link = true } = {}){
    const K = D.kleuren[k];
    if (!K || k === kleur) return;
    kleur = k;
    $$('[data-kleur][aria-pressed]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.kleur === k)));
    $$('[data-kleur-naam]').forEach(el => { el.textContent = K.naam; });
    $$('[data-kleur-zin]').forEach(el => { el.textContent = K.beschikbaar ? K.zin : vul(D.tekst.uitverkocht, { naam: K.naam }); });
    $$('[data-doos-kleur]').forEach(el => { el.textContent = K.doos; });
    $$('[data-kleur-img]').forEach(img => {
      const url = K.beelden[img.dataset.kleurImg]; if (!url) return;
      const nieuw = breedUrl(url, img.dataset.breedte || 1100);
      // dezelfde trap als snippets/kleur-beeld.liquid (data-breedtes), zodat sizes blijft kiezen (audit 05-10)
      const set = (img.dataset.breedtes || '').split(',').filter(Boolean).map(w => `${breedUrl(url, w)} ${w}w`).join(', ');
      // nog niet aan de beurt (wat hij kan, rechts): alleen het adres klaarzetten, niet laden
      if (img.hasAttribute('data-src')) { img.dataset.src = nieuw; if (set) img.dataset.srcset = set; else img.removeAttribute('data-srcset'); }
      else { if (set) img.srcset = set; else img.removeAttribute('srcset'); img.src = nieuw; }
      if (img.dataset.kleurAlt) img.alt = img.dataset.kleurAlt.replace('[naam]', K.naam);
    });
    // de mandjesknoppen: deze variant, of uit als hij op is
    $$('[data-kleur-volgt]').forEach(b => {
      b.dataset.variant = K.id; b.dataset.naam = K.naam; b.disabled = !K.beschikbaar;
      const t = $('[data-knop-tekst]', b); if (t) t.textContent = K.beschikbaar ? D.tekst.knop : D.tekst.op;
    });
    $$('[data-galerij] [data-set]').forEach(el => { el.hidden = el.dataset.set !== k; });
    zetTerug();
    balkB();
    tabRijen();
    $$('[data-ook-kleur]').forEach(el => { el.hidden = el.dataset.ookKleur === k; });
    if (link){ const u = new URL(location.href); u.searchParams.set('variant', K.id); u.searchParams.delete('kleur'); history.replaceState(history.state, '', u); }
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-kleur]'); if (!b) return;
    const k = b.dataset.kleur, anders = k !== kleur;
    zetKleur(k);
    if (b.hasAttribute('data-naar-boven')){
      $('.sectie[data-id="product"]').scrollIntoView({ behavior: gedrag(), block: 'start' });
      if (anders) meld(vul(D.tekst.klaar, { naam: D.kleuren[k].naam }));
    }
  });
  // een kleur uit de link (?kleur=wolk), zoals vanaf de kaarten in de shop; ?variant= regelt Shopify zelf
  const uitLink = (new URLSearchParams(location.search).get('kleur') || '').toLowerCase();
  if (D.kleuren[uitLink]) zetKleur(uitLink);
  // net aangemeld: terug naar de kleur van de aanmelding, met de bevestiging. Zonder opslag (privévenster) weet de
  // pagina de kleur niet; dan alleen een melding. ?customer_posted= gaat uit de url, anders meldt een herlaad het weer.
  if (gepost) {
    if (D.kleuren[terugKleur]) { if (terugKleur !== kleur) zetKleur(terugKleur); else zetTerug(); }
    else if (D.kleuren[kleur].beschikbaar) meld(vul(D.tekst.terugKlaar, { naam: D.tekst.terugJeKleur }));
    const u = new URL(location.href); u.searchParams.delete('customer_posted'); history.replaceState(history.state, '', u);
  }
  // ?kleur=wolk#terug, vanaf "Uitverkocht" elders op de site (audit 05-10): naar het mailveld. Het blok stond bij
  // het laden nog verborgen (de server kent ?kleur= niet), dus de browser kon er zelf niet heen springen. Met een
  // muis gaat de focus meteen in het veld; op een telefoon niet, anders schuift het toetsenbord over de pagina.
  // #terug-melding is de terugsprong van Shopify na het versturen.
  if (location.hash === '#terug' || location.hash === '#terug-melding') {
    const naarTerug = () => {
      const t = $('#terug'); if (!t || t.hidden) return;
      const r = t.getBoundingClientRect(), kop = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kop-h')) || 0;
      if (r.top < kop || r.bottom > innerHeight) t.scrollIntoView({ block: 'start' });
      if (matchMedia('(pointer: fine)').matches) $('input[type="email"]', t)?.focus({ preventScroll: true });
    };
    if (document.readyState === 'complete') naarTerug(); else addEventListener('load', naarTerug, { once: true });
  }

  /* =================== 3. aantal, galerij en lightbox =================== */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-pk-aantal] [data-stuks]'); if (!b) return;
    const n = b.dataset.stuks;
    $$('[data-pk-aantal] [data-stuks]').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.stuks === n)));
    // één regel met wat je bespaart, onder de tegels (review 04-10)
    $$('[data-pk-bespaar]').forEach(p => { p.hidden = !b.dataset.bespaar; p.textContent = b.dataset.bespaar ? vul((L.tekst || {}).staffelBespaar, { bedrag: b.dataset.bespaar, aantal: n }) : ''; });
    // alleen de grote knop in het koopblok doet er meer; de plakbalk en het cadeau doen er één
    $$('.pk-knop').forEach(k => { k.dataset.hoeveel = n; });
  });

  function balkB(){
    if (!galB) return;
    const rij = $(`.pg2-rij[data-set="${kleur}"]`, galB), i = $('.pg2-balk i', galB);
    if (!rij || !i) return;
    const max = rij.scrollWidth - rij.clientWidth, deel = rij.scrollWidth ? Math.min(1, rij.clientWidth / rij.scrollWidth) : 1;
    i.style.width = `${deel * 100}%`;
    i.style.left = `${max > 0 ? (rij.scrollLeft / max) * (1 - deel) * 100 : 0}%`;
  }
  // een rij die schuift (op ≤760 px) is een eigen tabstop, dan schuiven de pijltjes hem; op desktop staan de
  // beelden onder elkaar en is die extra tabstop overbodig (audit 05-10)
  function tabRijen(){
    if (!galB) return;
    $$('.pg2-rij', galB).forEach(rij => { if (!rij.hidden && rij.scrollWidth > rij.clientWidth + 1) rij.setAttribute('tabindex', '0'); else rij.removeAttribute('tabindex'); });
  }
  if (galB){
    $$('.pg2-rij', galB).forEach(rij => rij.addEventListener('scroll', () => requestAnimationFrame(balkB), { passive: true }));
    addEventListener('resize', () => { balkB(); tabRijen(); });
    balkB();
    tabRijen();
  }

  // de lightbox: alle beelden van de gekozen kleur groot; vegen, pijlen, Esc of ernaast tikken. Elk beeld heeft
  // een knop (.pg-open), dus hij opent ook met Enter of spatie; na sluiten gaat de focus terug naar die knop.
  const licht = $('[data-licht]'), lichtRij = $('[data-licht-rij]');
  let lichtK = null, opener = null;
  const lichtI = () => Math.round(lichtRij.scrollLeft / Math.max(1, lichtRij.clientWidth));
  function werkLichtBij(){
    const i = lichtI();
    $('[data-licht-vorige]', licht).disabled = i <= 0;
    $('[data-licht-volgende]', licht).disabled = i >= lichtRij.children.length - 1;
  }
  function openLicht(i){
    if (!licht || typeof licht.showModal !== 'function') return;
    if (lichtK !== kleur){
      const rij = $(`.pg2-rij[data-set="${kleur}"]`, galB);
      lichtRij.replaceChildren(...$$('figure', rij).map(f => {
        const k = f.cloneNode(true);
        $$('img', k).forEach(img => { img.loading = 'eager'; img.sizes = '100vw'; });
        $$('.pg-open', k).forEach(b => b.remove());
        return k;
      }));
      lichtRij.setAttribute('aria-label', rij.getAttribute('aria-label') || '');
      lichtK = kleur;
    }
    if (!licht.open) licht.showModal();
    requestAnimationFrame(() => { lichtRij.scrollTo({ left: i * lichtRij.clientWidth, behavior: 'instant' }); werkLichtBij(); });
  }
  if (galB && licht){
    galB.addEventListener('click', e => {
      const f = e.target.closest('figure'); if (!f) return;
      opener = $('.pg-open', f);
      openLicht($$(`.pg2-rij[data-set="${kleur}"] figure`, galB).indexOf(f));
    });
    // Chrome zet de focus zelf terug, maar alleen als de knop hem had (Safari geeft een knop bij een klik geen focus)
    licht.addEventListener('close', () => { if (opener?.isConnected && !opener.closest('[hidden]')) opener.focus(); });
    lichtRij.addEventListener('scroll', () => requestAnimationFrame(werkLichtBij), { passive: true });
    $('[data-licht-vorige]', licht).addEventListener('click', () => lichtRij.scrollBy({ left: -lichtRij.clientWidth, behavior: gedrag() }));
    $('[data-licht-volgende]', licht).addEventListener('click', () => lichtRij.scrollBy({ left: lichtRij.clientWidth, behavior: gedrag() }));
    $('[data-licht-sluit]', licht).addEventListener('click', () => licht.close());
    licht.addEventListener('click', e => { if (!e.target.closest('img, button, .pg-maat-beeld')) licht.close(); });
    licht.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();   // anders schuift de rij (een tabstop) er zelf ook nog een stukje bij
      lichtRij.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * lichtRij.clientWidth, behavior: gedrag() });
    });
  }

  /* =================== 3b. het koopblok loopt mee =================== */
  // Op een laptop is het koopblok ~1.340 px hoog en het scherm 770 tot 1.080. Het plakte meteen bovenaan,
  // dus de zekerheden eronder kwamen pas in beeld als de hele galerij voorbij was (Cehdi, 04-10). Nu plakt
  // het boven én onder (product.css): de onderrand houdt de onderkant van het blok in beeld, de bovenrand de
  // bovenkant. Bij elke omkering van de scrollrichting komt de opvulling (--koop-m) precies op de plek waar
  // het blok dan staat; daarvandaan scrolt het mee tot een van de twee randen. Het scrollen zelf doet de
  // browser, dus het blok hapert niet. Past het blok op het scherm, dan geldt gewoon de bovenrand.
  const koop = $('.pg2-koop'), pk = koop && $(':scope > .pk', koop);
  if (pk) {
    const RAND = 20, breed = matchMedia('(min-width: 761px)');
    let lang = false, omlaag = true, vorigeY = scrollY;
    const boven = () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kop-h')) || 0) + RAND;
    const px = n => `${Math.round(n)}px`;
    function hier(){
      const ruimte = koop.clientHeight - pk.offsetHeight;
      const m = pk.getBoundingClientRect().top - koop.getBoundingClientRect().top;
      koop.style.setProperty('--koop-m', px(Math.max(0, Math.min(m, ruimte))));
    }
    function maat(){
      const V = innerHeight, h = pk.offsetHeight, b = boven();
      lang = breed.matches && h > V - b - RAND;
      if (!lang) { ['--koop-m', '--koop-top', '--koop-onder'].forEach(k => koop.style.removeProperty(k)); return; }
      // eerst de huidige plek vastleggen, dan pas de randen: gaat er onderaan een uitklapper open, dan blijft
      // het blok staan waar het staat (anders schoof de aangeklikte regel 101 px omhoog onder de muis)
      hier();
      koop.style.setProperty('--koop-top', px(V - RAND - h));   // de onderkant niet hoger dan RAND boven de schermrand
      koop.style.setProperty('--koop-onder', px(V - b - h));    // de bovenkant niet lager dan net onder de kop
    }
    addEventListener('scroll', () => {
      const y = scrollY; if (y === vorigeY) return;
      const nu = y > vorigeY; vorigeY = y;
      if (lang && nu !== omlaag) hier();
      omlaag = nu;
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(maat).observe(pk);   // een uitklapper, het voorraadformulier
    addEventListener('resize', maat);
    maat();
  }

  /* =================== 4. de plakbalk: sinds 05-10 in assets/plakbalk.js =================== */

  /* =================== 5. per sectie =================== */
  // (Luister in het koopblok is weg sinds 04-10, Cehdi: de geluiden staan al in de secties eronder)
  let stopGeluid = null;
  document.addEventListener('geluid', ({ detail: d }) => {
    if (d.wie !== 'secties') return;
    stopGeluid = d.speelt ? d.stop : null;
    $$('[data-pf5]').forEach(el => el.classList.toggle('speelt', d.speelt && $('[data-pf5-speel]', el).classList.contains('speelt')));
  });

  // wat hij kan: probeer het dak. De noot speelt het volgende geluid via de verborgen knop met data-geluid,
  // de klok kiest de tijd, het schuifje geluid, licht of allebei. Het beeld draait naar de kant van de knop.
  $$('[data-pf5]').forEach(el => {
    const speelKnop = $('[data-pf5-speel]', el);
    const TIJDEN = [[40, '40 seconden'], [80, '80 seconden'], [120, '2 minuten'], [300, '5 minuten']];
    const STANDEN = { geluid: 'alleen geluid', licht: 'alleen licht', allebei: 'geluid en licht' };
    let g = 0, tijd = 0;
    const toon = (wat, tekst) => { $$(`[data-pf5-nu="${wat}"], [data-pf5-uit="${wat}"]`, el).forEach(o => { o.textContent = tekst; }); };
    const wijs = knop => {
      el.dataset.knop = knop;
      el.dataset.zij = knop === 'noot' || knop === 'klok' ? 'links' : 'rechts';
      if (el.dataset.zij === 'rechts') laad($('[data-pf5-huis="rechts"] img', el));
      $$('button[data-pf5-knop]', el).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.pf5Knop === knop)));
    };
    // De beelden die nog niet aan de beurt zijn, hebben hun adres in data-src (luvlyn-functies.liquid, audit 05-10):
    // de natuurfoto van het volgende geluid en het huisje van rechts laden pas als de knoppen in beeld komen,
    // en na elke tik op de noot de foto daarna. Zo laadt er nooit meer dan één foto vooruit.
    const laad = img => {
      if (!img || !img.hasAttribute('data-src')) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
    };
    const natuur = s => $(`[data-pf5-achter="${s}"]`, el);
    const vooruit = () => { laad(natuur(GELUIDEN[(g + 1) % GELUIDEN.length])); laad($('[data-pf5-huis="rechts"] img', el)); };
    const knoppen = $('.pf5-knoppen', el) || el;
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { vooruit(); io.disconnect(); } });
      io.observe(knoppen);
    } else vooruit();
    // de ringen op het dak pulseren alleen als het dak in beeld is (product.css, audit 05-10)
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => el.classList.toggle('in-beeld', e.isIntersecting)).observe(el);
    const achter = naam => { laad(natuur(naam)); $$('[data-pf5-achter]', el).forEach(img => img.classList.toggle('aan', img.dataset.pf5Achter === naam)); };
    $('[data-pf5-knop="noot"]', el).addEventListener('click', () => {
      wijs('noot');
      g = (g + 1) % GELUIDEN.length;
      const s = GELUIDEN[g], naam = GELUID[s].naam;
      speelKnop.dataset.geluid = s; speelKnop.textContent = naam;
      toon('geluid', naam); achter(s); vooruit();
      // alleen licht: dan speelt hij geen geluid, net als het echte huisje
      if (el.dataset.stand !== 'licht') speelKnop.click();
    });
    $('[data-pf5-knop="klok"]', el).addEventListener('click', () => {
      wijs('klok');
      tijd = (tijd + 1) % TIJDEN.length;
      toon('tijd', TIJDEN[tijd][1]);
      $('.pf5-klok', el).style.setProperty('--deel', (TIJDEN[tijd][0] / 300).toFixed(3));
    });
    $('[data-pf5-knop="wiel"]', el).addEventListener('click', () => wijs('wiel'));
    $$('[data-pf5-stand]', el).forEach(b => b.addEventListener('click', () => {
      wijs('schuif');
      el.dataset.stand = b.dataset.pf5Stand;
      $$('[data-pf5-stand]', el).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      toon('stand', STANDEN[b.dataset.pf5Stand]);
      // alleen licht: het geluid stopt. Geluid of allebei: het geluid speelt (door), zoals op het huisje (Cehdi, 03-10)
      if (b.dataset.pf5Stand === 'licht'){ if (stopGeluid && speelKnop.classList.contains('speelt')) stopGeluid(); }
      else if (!speelKnop.classList.contains('speelt')) speelKnop.click();
    }));
    $('.pf5-schuif', el).addEventListener('click', e => { if (!e.target.closest('[data-pf5-stand]')) wijs('schuif'); });
  });

  // waarom zeven geluiden: de golf per seconde; het riedeltje is de eerste 8 seconden, steeds opnieuw
  $$('[data-golven]').forEach(fig => {
    const lang = (fig.dataset.golfWaarden || '').split(',').map(Number).filter(n => !Number.isNaN(n));
    if (!lang.length) return;
    const golf = { lang, kort: Array.from({ length: lang.length }, (_, i) => lang[i % 8]) };
    const laag = Math.min(...lang), hoog = Math.max(...lang);
    Object.entries(golf).forEach(([soort, waarden]) => {
      const el = $(`[data-golf="${soort}"]`, fig);
      if (el) el.innerHTML = waarden.map((v, i) => `<i style="--h:${(.14 + .86 * (v - laag) / (hoog - laag)).toFixed(3)};--i:${i}"></i>`).join('');
    });
    const kijk = new IntersectionObserver(([e]) => { if (e.isIntersecting){ fig.classList.add('zicht'); kijk.disconnect(); } }, { threshold: .35 });
    kijk.observe(fig);
  });

  // reviews: eerst een handvol, met "Toon meer reviews" telkens twaalf erbij. Alle staan in de HTML, en na de
  // zesde al met hidden (luvlyn-reviews.liquid, audit 05-10); hier gaan ze alleen open. De focus gaat naar de
  // eerste nieuwe review.
  $$('[data-pr-meer]').forEach(blok => {
    const items = $$('[data-pr-item]', blok), knop = $('[data-pr-meer-knop]', blok), telling = $('[data-pr-telling]', blok);
    const totaal = items.length, STAP = 12;
    let n = Math.min(totaal, +(blok.dataset.prBegin || 6));
    const zet = () => {
      items.forEach((it, i) => { const dicht = i >= n; if (it.hidden !== dicht) it.hidden = dicht; });
      knop.hidden = n >= totaal;
      telling.textContent = n >= totaal ? vul(telling.dataset.tekstAlle, { totaal }) : vul(telling.dataset.tekstVan, { n, totaal });
    };
    knop.addEventListener('click', () => {
      const was = n;
      n = Math.min(totaal, n + STAP);
      if (totaal - n < 4) n = totaal;   // geen staartje van twee of drie
      // de nieuwe stonden op hidden, dus hun animatie begint vanzelf zodra ze verschijnen: geen reflow per review
      items.slice(was, n).forEach((it, k) => { it.style.setProperty('--n', Math.min(k, 8)); it.firstElementChild.classList.add('pr-nieuw'); });
      zet();
      items[was]?.focus({ preventScroll: true });
    });
    zet();
  });

  Object.assign(L, { zetKleur });
})();
